import angular from 'angular';

angular.module('app-lite.websockets', []);